// @core/api/endpoints/workflow/install_product_pipelines.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InstallProductPipelinesRequest,
  InstallProductPipelinesResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Install product pipelines
 * Finds all pipeline templates with auto_install=true for the given product_slug and installs them into the current tenant. Pipelines are created in active+published status. Idempotent — skips templates that are already installed.
 */
export async function InstallProductPipelines(
  data: InstallProductPipelinesRequest,
  options?: RequestOptions
): Promise<InstallProductPipelinesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/templates/install-product`;
  const requestOptions = options;
  return client.post<InstallProductPipelinesResponse>(requestPath, data, requestOptions);
}
